/**
 * Полифилл crypto.randomUUID для старых браузеров (например, iOS 15.3.x, где его нет).
 * Подключать как можно раньше, чтобы код из бандла и зависимостей не падал с TypeError.
 */
export default defineNuxtPlugin({
  name: 'crypto-randomUUID-polyfill',
  enforce: 'pre',
  setup () {
    if (import.meta.server || typeof globalThis?.crypto?.randomUUID === 'function') {
      return;
    }
    const crypto = globalThis.crypto;
    if (!crypto?.getRandomValues) {
      return;
    }
    type UUID = `${string}-${string}-${string}-${string}-${string}`;
    (crypto as Crypto & { randomUUID?: () => UUID }).randomUUID = function randomUUID (): UUID {
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0]! & 15 >> +c / 4).toString(16)
      ) as UUID;
    };
  }
});
